import React from "react";

const DashedSeparator = ({ className }) => (
  <div className={className} style={{ borderBottom: "1px dashed #E2DBD5" }} />
);

export default DashedSeparator;
